module.exports = __webpack_public_path__ + "static/media/6.023e7cf6.png";